@import '../../styles/palette.scss';

.alpIcon {
  fill: _palette(text);
}

.warningIcon {
  color: _palette(warning-icon);
}

.commonIcon {
  font-size: 1.5rem;
  width: 1em;
}
